
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { getPolicy } from 'texts/cookies/texts';
import { Namespace } from 'enums/namespaces';
import { basicSEO } from 'helpers/jsx';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import React from 'react';
import { StaticPathParams } from 'typings/staticPaths';
import Layout from '../../components/Layout';
import styles from './index.module.scss';

interface Props {
  countryCode: string;
}

const Cookies: NextPage<Props> = ({ countryCode }) => {
  const { lang, t } = useTranslation(Namespace.Common);

  return (
    <Layout countryCode={countryCode}>
      <main className={styles.legal}>
        <Head>{basicSEO(t('seo:cookies_title'), t('seo:cookies_description'))}</Head>
        <p className={styles.updated}>{t('cookie_updated')}</p>
        {getPolicy(lang)}
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { countryCode } = await authorizeUserServerSide(ctx);

  return {
    props: { countryCode },
  };
}

export default Cookies;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/cookies/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  